import { LocalStorage } from '@vromo/models';
import Container from '@vromo/ui/components/Container';
import Flex from '@vromo/ui/components/Flex';
import Switch from '@vromo/ui/components/Switch';
import theme from '@vromo/ui/components/theme';
import { runInAction } from 'mobx';
import React, { ReactElement, memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './betaSettings.style';

const MemoSwitch = memo(Switch);

const BetaSettings = (): ReactElement => {
    const { t } = useTranslation();
    const translate = (key: string, params?: any) => t(`settings.${key}`, params);
    const [isBeta, setIsBeta] = useState(LocalStorage.enterpriseDispatch as boolean);

    useEffect(() => {
        runInAction(() => {
            if (isBeta) {
                LocalStorage.enterpriseDispatch = true;
                delete LocalStorage.enterpriseDispatchInfoBannerIsDismissed;
            } else delete LocalStorage.enterpriseDispatch;
        });
    }, [isBeta]);

    const onChangeDispatchBeta = useCallback(() => setIsBeta((prev) => !prev), []);

    return (
        <Container title={translate('betaSettings')}>
            <div style={styles.formGroup}>
                <Flex horizontal="between" vertical="middle">
                    <div style={styles.switchTitle}>
                        <strong>{translate('enterpriseDispatchScreen')}</strong>
                        <br />
                        {translate('betaDisptachDescription')}
                    </div>
                    <div>
                        <MemoSwitch
                            color={theme.success}
                            checked={isBeta}
                            onChange={onChangeDispatchBeta}
                            style={styles.switch}
                        />
                    </div>
                </Flex>
            </div>
        </Container>
    );
};

export default memo(BetaSettings);
